{
  "name": "sso",
  "version": "2.12.0",
  "$schema": "../../node_modules/nx/schemas/project-schema.json",
  "projectType": "application",
  "sourceRoot": "apps/sso/src",
  "prefix": "ciphr",
  "targets": {
    "build": {
      "executor": "@angular-devkit/build-angular:browser-esbuild",
      "outputs": ["{options.outputPath}"],
      "options": {
        "allowedCommonJsDependencies": ["qrcode"],
        "outputPath": "dist/apps/sso",
        "index": "apps/sso/src/index.html",
        "main": "apps/sso/src/main.ts",
        "polyfills": ["zone.js"],
        "tsConfig": "apps/sso/tsconfig.app.json",
        "inlineStyleLanguage": "scss",
        "assets": [
          "apps/sso/src/favicon.ico",
          "apps/sso/src/staticwebapp.config.json",
          "apps/sso/src/silent-refresh.html",
          "apps/sso/src/silent-refresh.js",
          "apps/sso/src/assets",
          {
            "glob": "*.svg",
            "input": "./node_modules/@ciphr-design-system/icons/svg/",
            "output": "./assets/icons"
          },
          {
            "glob": "*.svg",
            "input": "./node_modules/@ciphr-design-system/illustrations/svg/",
            "output": "./assets/illustrations"
          }
        ],
        "styles": ["apps/sso/src/styles.scss"],
        "scripts": []
      },
      "configurations": {
        "production": {
          "budgets": [
            {
              "type": "initial",
              "maximumWarning": "500kb",
              "maximumError": "1mb"
            },
            {
              "type": "anyComponentStyle",
              "maximumWarning": "2kb",
              "maximumError": "4kb"
            }
          ],
          "outputHashing": "all"
        },
        "development": {
          "sourceMap": true
        },
        "local": {
          "buildOptimizer": false,
          "optimization": false,
          "vendorChunk": true,
          "extractLicenses": false,
          "sourceMap": true,
          "namedChunks": true
        }
      },
      "defaultConfiguration": "production"
    },
    "serve": {
      "executor": "@angular-devkit/build-angular:dev-server",
      "options": {
        "proxyConfig": "apps/sso/proxy.conf.json"
      },
      "configurations": {
        "production": {
          "buildTarget": "sso:build:production"
        },
        "development": {
          "buildTarget": "sso:build:development"
        },
        "local": {
          "buildTarget": "sso:build:local"
        }
      },
      "defaultConfiguration": "local",
      "continuous": true
    },
    "serve-with-mock-api": {
      "executor": "nx:run-commands",
      "options": {
        "commands": [
          {
            "command": "nx run dev-api:serve"
          },
          {
            "command": "nx run sso:serve"
          }
        ],
        "parallel": true
      }
    },
    "extract-i18n": {
      "executor": "@angular-devkit/build-angular:extract-i18n",
      "options": {
        "buildTarget": "sso:build"
      }
    },
    "lint": {
      "executor": "@nx/eslint:lint"
    },
    "test": {
      "executor": "@nx/jest:jest",
      "outputs": ["{workspaceRoot}/coverage/{projectRoot}"],
      "options": {
        "jestConfig": "apps/sso/jest.config.ts",
        "passWithNoTests": true
      }
    },
    "sonar-prepare": {
      "executor": "@ciphr/sonar:prepare-to-scan"
    }
  },
  "tags": []
}
